import { UnleashClient } from '@unleash/proxy-client-react';
import { getUser } from 'auth';
import type { UnleashContext } from './hooks';

const environments = {
  dev: 'development',
  staging: 'development',
  production: 'production',
};

let unleashEnv = environments.dev;

if (window.ENV !== undefined) {
  unleashEnv = environments[window.ENV];
}
const clientKey = window.UNLEASH_CLIENT_KEY;
const appName = window.UNLEASH_APP_NAME;
const config = {
  url: window.UNLEASH_PROXY_URL || `${window.location.origin}/proxy`,
  refreshInterval: window.UNLEASH_REFRESH_INTERVAL
    ? parseInt(window.UNLEASH_REFRESH_INTERVAL, 10)
    : 15,
  environment: unleashEnv,
  clientKey,
  appName,
};

let unleashClientInstance: UnleashClient | null = null;

// Function to initialize and get the Unleash client
export const getUnleashClient = (): UnleashClient => {
  if (!unleashClientInstance && clientKey && appName) {
    unleashClientInstance = new UnleashClient({
      ...config,
      clientKey,
      appName,
    });
  }

  if (!unleashClientInstance) {
    throw new Error('Unleash client not initialized.');
  }
  return unleashClientInstance;
};
